import React, { Component } from "react"
import Img from 'gatsby-image'

import Slider from "react-slick"

class Gallery extends Component {
  render() {

    let settings = {
      infinite: true,
      speed: 500,
      centerMode: true,
      centerPadding: "60px",
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 720,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    };

    let images = this.props.house.gallery

    return(
      <div>
        <Slider
          {...settings}
          className="gallery"
        >
          { images.map(image => {
            return(
              <div
                className="gallery__slide"
              >
                <Img
                  sizes={ image.sizes }
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 1,
                  }}
                />
              </div>
            )
          })}
        </Slider>
      </div>
    )
  }
}

export default Gallery



// WEBPACK FOOTER //
// ./src/components/Gallery/index.js